import DetailLeftBlock from './DetailLeftBlock';

export default DetailLeftBlock;
